import { render, staticRenderFns } from "./AddVideo.vue?vue&type=template&id=16595f8e&"
import script from "./AddVideo.vue?vue&type=script&lang=js&"
export * from "./AddVideo.vue?vue&type=script&lang=js&"
import style0 from "./AddVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports